import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-dialog-lobby',
  templateUrl: './confirm-dialog-lobby.component.html',
  styleUrls: ['./confirm-dialog-lobby.component.css']
})
export class ConfirmDialogLobbyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
